export const AuthQuota = ({ auth, handleChange, error }) => {

  return (<>
    <div className="row">
      <div className="col col-12 ">
        <h4>
          Quota d'inscripcions
        </h4>

        <p>
          <input type="checkbox" id="authQuota" name="authQuota" value={auth} checked={auth === "1" ? true : false} onChange={(t) => { handleChange(t.target.value) }} required />
          <label htmlFor="authQuota"> Em dono per assabentat/da que, en cas d’estar donat d’alta com a treballador/a, estar percebent la prestació d'atur , tenir més de 28 anys, no compleixo els requisits pera a poder gaudir de les prestacions de l’assegurança escolar.  </label>
          <span id="auhtQuota_ERROR" className="a-Form-error">{error}</span>
        </p>

      </div>
    </div>
  </>)
}
